import { FaFacebookF, FaInstagram, FaLinkedin } from "react-icons/fa";

const CustomFooterMobile = ({
  textes,
  isBackgroundWhite,
  minimified = false,
}) => {
  return (
    <footer className="footer-section py-8 px-4">
      <div className="mx-auto">
        {!minimified && (
          <>
            <div className="relative flex py-5 items-center  text-center mt-20 mx-auto">
              <div class="flex-grow border-t border-gray-400 "></div>
              <p
                className={
                  "text-2xl md:text-2xl flex-shrink mx-4 max-w-[50vw] " +
                  (isBackgroundWhite ? "text-black" : "text-white")
                }
                style={{ fontFamily: "Lexend" }}
              >
                Un projet <span className="font-sam color-primary"> animé</span>{" "}
                <br />
                et <span className="font-sam color-primary">mouvementé</span> ?
              </p>
              <div class="flex-grow border-t border-gray-400"></div>
            </div>
            {/* Email contact section could go here if needed */}
            <div className="mx-auto mt-8 mb-8">
              <p
                className={`text-center ${
                  isBackgroundWhite ? "text-black" : "text-white"
                }`}
              >
                <a
                  href="mailto:bonjour@studio-sam.fr"
                  className={`border-[#00FFCC] border-2 p-4 text-xl ${
                    isBackgroundWhite ? "text-black" : "text-white"
                  }`}
                  style={{ fontFamily: "Lexend" }}
                >
                  bonjour@
                  <span className="font-sam color-primary">studio-sam</span>
                  .fr
                </a>
              </p>
            </div>
          </>
        )}

        <div className="flex flex-row items-center justify-between space-y-8 ">
          {/* Logo section */}
          <div className="text-center">
            <h2
              className={`text-6xl ml-5 mt-5 ${
                isBackgroundWhite ? "text-black" : "text-white"
              }`}
              style={{ fontFamily: "SAM" }}
            >
              sam
            </h2>
          </div>
          {/* Social icons */}
          <div className="flex space-x-6">
            <a
              href={textes?.facebookLink}
              target="_blank"
              rel="noopener noreferrer"
              className={`hover:text-green-400 transition-colors duration-300 ${
                isBackgroundWhite ? "text-black" : "text-white"
              }`}
            >
              <FaFacebookF size={12} />
            </a>
            <a
              href={textes?.instagramLink}
              target="_blank"
              rel="noopener noreferrer"
              className={`hover:text-green-400 transition-colors duration-300 ${
                isBackgroundWhite ? "text-black" : "text-white"
              }`}
            >
              <FaInstagram size={12} />
            </a>
            <a
              href={textes?.linkedinLink}
              target="_blank"
              rel="noopener noreferrer"
              className={`hover:text-green-400 transition-colors duration-300 ${
                isBackgroundWhite ? "text-black" : "text-white"
              }`}
            >
              <FaLinkedin size={12} />
            </a>
          </div>
          {/* Copyright */}
          <div
            className={`text-s md:text-xl text-right mr-3  ${
              isBackgroundWhite ? "text-black" : "text-white"
            }`}
            style={{ fontFamily: "Lexend" }}
          >
            {"Copyright " + new Date().getFullYear()}
            <br />
            All Rights Reserved.
            <br />
            Made by{" "}
            <a
              href="https://reeboot.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="color-primary"
            >
              Reeboot
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default CustomFooterMobile;
